// Put your application javascript here

const ErrorHelper = {
  validateRequiredFields: function (showErrors = false) {
    let isValid = true;
    const requiredFields = document.querySelectorAll('[field-required]');

    requiredFields.forEach(function (field) {
      const input = field.querySelector('input, select, textarea');
      const errorMessage = field.querySelector('[selector-error-message]');
      // Check if the field is empty or unchecked
      if (!input.value.trim() || (input.type === 'checkbox' && !input.checked)) {
        if (showErrors) {
          field.classList.add('show-error');
          input.setAttribute('aria-invalid', true);
          if (errorMessage?.id) input.setAttribute('aria-describedby', errorMessage.id);
        }
        isValid = false;
      } else {
        field.classList.remove('show-error');
        input.removeAttribute('aria-invalid')
        input.removeAttribute('aria-describedby');
      }

      // EKH: 149579
      setTimeout(() => {
        var errs = jquery('.show-error');
        if( errs.length > 0 ){
          jquery('.show-error:first').find('input').focus();
          jquery('.show-error:first').find('input')[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
      }, "100");


    });

    const generalErrorField = document.querySelector('[selector-general-error]');
    if (generalErrorField) {
      if (!isValid) {
        if (showErrors) {
          generalErrorField.classList.remove('hide');
          document.getElementById('MainContent').focus();
          window.scrollTo({ top: 200, behavior: 'smooth' });
        }
      } else {
        generalErrorField.classList.add('hide');
      }
    }

    return isValid;
  },
  // Function to add error message div after the existing div
  addAdditionalError: function (fieldContainer, message, styleType) {
    if (fieldContainer) {
      fieldContainer.classList.remove('show-error');
      const additionalErrorChild = fieldContainer.querySelector('[selector-error-additional]');
      // Create a new div for the error message
      if (!additionalErrorChild) {
        const newErrorDiv = document.createElement('div');
        newErrorDiv.className = `field-error error-text ${styleType !== 'bold' ? 'microcopy' : ''}`;
        newErrorDiv.setAttribute('selector-error-additional', '');
        newErrorDiv.setAttribute('aria-live', 'assertive');
        newErrorDiv.textContent = message;
        fieldContainer.appendChild(newErrorDiv);

        jquery(fieldContainer).find('input').focus();
        jquery(fieldContainer).find('input')[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });

      } else {
        additionalErrorChild.textContent = message;
      }

    }
  },

  // Function to remove error message div
  removeAdditionalError: function (fieldContainer) {
    const errorDivToRemove =  fieldContainer.querySelector(`[selector-error-additional]`);

    if (errorDivToRemove) {
      // Remove the error message div
      errorDivToRemove.parentNode.removeChild(errorDivToRemove);
    }
  }
};

window.ErrorHelper = ErrorHelper;

const FieldHelper = {
  hideValidationMessage: function (el) {
    const node = el[0] || el;
    const fieldLoader = node.querySelector('.field-loader');
    if (fieldLoader) fieldLoader.remove();
  },
  showValidatingMessage: function (el) {
    const node = el[0] || el;
    const icon = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
        <radialGradient id="a23" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
        <stop offset="0" stop-color="#0E8A16"/>
        <stop offset="0.28" stop-color="#0E8A16" stop-opacity="0.807487"/>
        <stop offset="0.935" stop-color="#0E8916" stop-opacity="0"/>
        <stop offset="1" stop-color="#0E8916" stop-opacity="0"/>
        </radialGradient>
        <circle transform-origin="center" fill="none" stroke="url(#a23)" stroke-width="15" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
        <animateTransform fill="freeze" type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
        </circle>
        <circle transform-origin="center" fill="none" opacity=".2" stroke="#0E8A16" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
      </svg>
    `;
    const value = node.querySelector('input').value;
    this.hideValidationMessage(el);
    if (value) {
      node.querySelector('label').insertAdjacentHTML('afterend', `<div class="field-loader">Verifying email...<span class="icon">${icon}</span></div>`)
    }
  },
  showValidMessage: function (el) {
    const node = el[0] || el;
    const icon = `
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 10C5.65661 10 6.30679 9.87067 6.91342 9.6194C7.52005 9.36812 8.07124 8.99983 8.53553 8.53553C8.99983 8.07124 9.36812 7.52005 9.6194 6.91342C9.87067 6.30679 10 5.65661 10 5C10 4.34339 9.87067 3.69321 9.6194 3.08658C9.36812 2.47995 8.99983 1.92876 8.53553 1.46447C8.07124 1.00017 7.52005 0.631876 6.91342 0.380602C6.30679 0.129329 5.65661 -9.78424e-09 5 0C3.67392 1.97602e-08 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10ZM4.87111 7.02222L7.64889 3.68889L6.79556 2.97778L4.40667 5.84389L3.17056 4.60722L2.385 5.39278L4.05167 7.05944L4.48167 7.48945L4.87111 7.02222Z" fill="#0E8916"/>
      </svg>
    `;
    const value = node.querySelector('input').value;
    const fieldLoader = node.querySelector('.field-loader');
    if (fieldLoader && value) {
      fieldLoader.innerHTML = `Verified<span class="icon">${icon}</span>`;
    }
  },
}

window.FieldHelper = FieldHelper;

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('select[data-default]').forEach(function (select) {
    if (select.dataset.default) select.value = select.dataset.default;
  });
});

function setLinkLang(lang) {
  function setLink(el, type = 'lang') {
    let newUrl = el?.href;
    if (!newUrl) return;

    const baseUrl = new URL(newUrl);
    switch (type) {
      case 'url': {
        let newPathname = baseUrl.pathname;
        // Check if the pathname already contains a language code at the beginning
        if (/^\/[a-zA-Z]{2}\//.test(newPathname)) {
          // Replace the existing language code with the new one
          newPathname = newPathname.replace(/^\/[a-zA-Z]{2}\//, `/${lang}/`);
        } else {
          // Prepend the language code if it doesn't exist
          newPathname = `/${lang}${newPathname}`;
        }

        newUrl = baseUrl.origin + newPathname + baseUrl.search + baseUrl.hash;
        break;
      }
      default: {
        const url = new URL(el.href);
        url.searchParams.set('lang', lang);
        newUrl = url.href;
        break;
      }
    }

    el.href = newUrl;
  }

  document.querySelectorAll('[data-localization]').forEach((el) => {
    const type = el.dataset.localization;
    setLink(el, type);
  });

  document.querySelectorAll('.link-localization a').forEach((el) => {
    setLink(el, 'url');
  });

  document.querySelectorAll('.link-localization').forEach((el) => {
    setLink(el, 'url');
  });
};

Weglot.on("initialized", function(currLang) {
  setLinkLang(currLang);
});
Weglot.on("languageChanged", function(newLang, prevLang) {
  setLinkLang(newLang);
});

function checkInputValues() {
  const inputs = document.querySelectorAll('.field-element');
  inputs.forEach(input => {
    if (input.value) {
      input.classList.add('field-has-value');
    } else {
      input.classList.remove('field-has-value');
    }
  });
}

// Initial check on page load
checkInputValues();

// Check inputs on input event (for dynamic changes)
document.querySelectorAll('.field-element').forEach(input => {
  input.addEventListener('input', checkInputValues);
});


var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
function validateEmail(email) {
  if (!email) return false;
  var emailParts = email.split('@');
  if (emailParts.length !== 2) return false;
  var account = emailParts[0];
  var address = emailParts[1];
  if (account.length > 64) return false;
  else if (address.length > 255) return false;
  var domainParts = address.split('.');
  if (domainParts.some(function (part) {
    return part.length > 63;
  })) return false;
  return tester.test(email);
};


/** Save Personal info form step4 to localstorage logic **/
// Function to save the entire form data as a single object in localStorage
function saveFormToLocalStorage() {
  const form = document.querySelector('[form-personal-info]');
  const formData = new FormData(form);
  const formObject = {};

  // Convert FormData to an object
  formData.forEach((value, key) => {
    formObject[key] = value;
  });

  // Save the object in localStorage as a JSON string
  localStorage.setItem('form-personal-info', JSON.stringify(formObject));
}

// Function to pre-fill the form with data from localStorage
function prefillForm() {
  const form = document.querySelector('[form-personal-info]');
  if (!form) return null;
  const storedFormData = localStorage.getItem('form-personal-info');

  if (storedFormData) {
    const formObject = JSON.parse(storedFormData);

    // Iterate through form fields and pre-fill with stored data
    for (const [key, value] of Object.entries(formObject)) {
      if (form.elements[key]) {
        form.elements[key].value = value;
        if (value) form.elements[key].classList.add('field-has-value');
      }
    }
    const event = new Event('change', { bubbles: true });
    form.dispatchEvent(event);
  }
}

// Add event listeners for form changes and submission
const form = document.querySelector('[form-personal-info]');
if (form) {
  form.addEventListener('change', saveFormToLocalStorage);
}

window.onload = prefillForm;
